import React from 'react';
import { Download, FileText, CheckCircle, XCircle, Map, Database, GitMerge, FileBadge, Tag, Palette, Users, ShieldCheck, Globe, ClipboardCheck, Eye } from 'lucide-react';

const DataDetailTable = ({ dataDetail, catatan, config, onUnsealPeta, onChecklistView, checklistStatus, availableChecklists = {}, onViewMetadata }) => {
    const documentItems = [
        { label: 'Peta', key: 'peta', icon: <Map className="document-lucide-icon" /> },
        { label: 'Struktur Data', key: 'struktur_data', icon: <Database className="document-lucide-icon" /> },
        { label: 'Mekanisme dan Tata Kerja Pembuatan IGT', key: 'takel', icon: <GitMerge className="document-lucide-icon" /> },
        { label: 'Dokumen Penetapan', key: 'dokumen', icon: <FileBadge className="document-lucide-icon" /> },
        { label: 'Metadata', key: 'metadata', icon: <Tag className="document-lucide-icon" /> },
        { label: 'Simbology', key: 'simbology', icon: <Palette className="document-lucide-icon" /> },
        { label: 'Role Akses', key: 'role', icon: <Users className="document-lucide-icon" /> },
        { label: 'Kontrol Kualitas', key: 'kualitas', icon: <ShieldCheck className="document-lucide-icon" /> },
        { label: 'Cakupan', key: 'cakupan', icon: <Globe className="document-lucide-icon" /> },
    ];

    const getStatusIcon = (status) => {
        if (status === 'Sesuai') {
            return <CheckCircle size={16} className="status-icon-approved" />;
        } else if (status === 'Tidak Sesuai') {
            return <XCircle size={16} className="status-icon-rejected" />;
        }
        return null;
    };

    const getStatusClass = (status) => {
        if (status === 'Sesuai') return 'status-approved';
        if (status === 'Tidak Sesuai') return 'status-rejected';
        return 'status-pending';
    };

    return (
        <div className="detail-table-section">
            <h3 className="section-title">Detail Verifikasi Dokumen</h3>
            <div className="table-wrapper">
                <div className="table-container">
                    <table className="detail-table">
                        <thead>
                            <tr>
                                <th className="col-document">Dokumen</th>
                                <th className="col-file">File</th>
                                <th className="col-notes">Catatan Verifikator</th>
                                <th className="col-status">Status Verifikasi</th>
                            </tr>
                        </thead>
                        <tbody>
                            {documentItems.map((item) => {
                                const notes = catatan?.[item.key]?.split('|')[0] || '';
                                const status = catatan?.[item.key]?.split('|')[1] || '';
                                const hasFile = dataDetail[item.key];

                                return (
                                    <tr key={item.key} className={hasFile ? 'row-with-file' : 'row-no-file'}>
                                        <td className="document-cell">
                                            <div className="document-info">
                                                <span className="document-icon">{item.icon}</span>
                                                <span className="dok-name">{item.label}</span>
                                            </div>
                                        </td>

                                        <td className="file-cell">
                                            {item.key === 'cakupan' ? (
                                                <div className="cakupan-text-inline">
                                                    {dataDetail.cakupan || 'Tidak ada informasi cakupan'}
                                                </div>
                                            ) : (
                                                hasFile ? (
                                                    <div className="file-download-container">
                                                        {item.key === 'peta' && dataDetail.status_enkripsi === 'sealed' ? (
                                                            <button
                                                                onClick={() => onUnsealPeta({ noTiket: dataDetail.no_tiket, namaIgt: dataDetail.nama_igt })}
                                                                className="file-download-btn"
                                                                title="Unduh & Dekripsi Peta"
                                                            >
                                                                <Download size={14} />
                                                                <span>Unduh File {item.label}</span>
                                                            </button>
                                                        ) : item.key === 'metadata' ? (
                                                            <div className="metadata-actions">
                                                                <a
                                                                    href={`${config.API_URL}/download/${btoa(dataDetail[item.key].split('/').pop())}`}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="file-download-btn"
                                                                    title={`Download ${item.label}`}
                                                                >
                                                                    <FileText size={16} />
                                                                    <span>Unduh</span>
                                                                    <Download size={14} />
                                                                </a>
                                                                {onViewMetadata && !dataDetail[item.key]?.toLowerCase().endsWith('.zip') && (
                                                                    <button
                                                                        onClick={onViewMetadata}
                                                                        className="file-download-btn view-metadata-btn"
                                                                        title="Lihat Detail Metadata"
                                                                    >
                                                                        <Eye size={16} />
                                                                        <span>Lihat Detail</span>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <a
                                                                href={`${config.API_URL}/download/${btoa(dataDetail[item.key].split('/').pop())}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="file-download-btn"
                                                                title={`Download ${item.label}`}
                                                            >
                                                                <FileText size={16} />
                                                                <span>Unduh File {item.label}</span>
                                                                <Download size={14} />
                                                            </a>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="no-file-indicator">
                                                        <span>File tidak tersedia</span>
                                                    </div>
                                                )
                                            )}
                                        </td>
                                        <td className="notes-cell">
                                            <div className="notes-content">
                                                {notes ? (<p>{notes}</p>) : (<span className="no-notes">Tidak ada catatan</span>)}
                                            </div>
                                        </td>

                                        <td className="status-cell">
                                            <div className="status-with-checklist">
                                                <div className={`status-badge ${getStatusClass(status)}`}>
                                                    {getStatusIcon(status)}
                                                    <span>{status}</span>
                                                </div>
                                                {availableChecklists[item.key] && checklistStatus[item.key] && (
                                                    <button
                                                        onClick={() => onChecklistView(item.key)}
                                                        className={`checklist-view-btn-icon has-data`}
                                                        title="Lihat Hasil Checklist"
                                                    >
                                                        <ClipboardCheck size={16} />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default DataDetailTable;